<template>
  <div class="bg-white mt-5 rounded p-3">
    <div class="w-full flex flex-col md:flex-row justify-between border-b py-5 mb-5">

      <div class="w-32 h-32 p-4 -mt-20 ml-4 mb-2 text-white rounded-lg relative flex-no-shrink bg-tertiary mr-5">
        <icon name="evaluate"></icon>
      </div>

      <div class="flex-1 flex flex-col items-center md:flex-row">
        <button @click="tab = 'leads'" class="p-3 text-grey text-lg font-bold md:mr-3">
          <span class="border-b-2 border-white p-2" :class="{'text-grey-darkest border-blue': tab === 'leads'}">Leads</span>
        </button>

        <button @click="tab = 'links'" class="p-3 text-grey text-lg font-bold md:mr-3">
          <span class="border-b-2 border-white p-2" :class="{'text-grey-darkest border-blue': tab === 'links'}">Links</span>
        </button>

        <button v-if="profile && profile.type <= 4" @click="tab = 'module-settings'" class="p-3 text-grey text-lg font-bold md:mr-3">
          <span class="border-b-2 border-white p-2" :class="{'text-grey-darkest border-blue': tab === 'module-settings'}">
            Settings
          </span>
        </button>

      </div>
    </div>

    <leads v-if="tab === 'leads'"></leads>
    <links v-if="tab === 'links'"></links>
    <module-settings v-if="tab === 'module-settings'"></module-settings>
  </div>
</template>

<script>
import Leads from './Leads'
import Links from './Links'
import { mapState } from 'vuex'
import ModuleSettings from './ModuleSettings'

export default {
  name: 'evaluateSettings',

  components: {
    Leads,
    Links,
    ModuleSettings
  },

  data () {
    return {
      tab: 'leads'
    }
  },

  created () {
  },

  computed: {
    ...mapState(['profile'])
  },

  methods: {

  }
}
</script>
